
export class SubCategoryConstants {
    public static POSEasyShopSKUSales = 'POS/Easy Shop SKU Sales';
    public static POSEODOrderSummary = 'POS EOD Order Summary';
    public static OrdersReport = 'Orders Report';
    public static OrdersDashboard = 'Order Dashboard Report';
    public static BSNReport = 'BSN Report';
    public static IBANReport = 'SEPA Direct Debit Mandate/Credit Assessment';
    public static AccountStatusChange = 'Status Changes';
    public static EnrollmentReport = 'Enrollment Report';
} 

export const InvoicePrintStatus = [
    {
        value: 19, key: 'Printed'
    },
    {
        value: 20, key: 'Not Printed'
    }
]

export enum SortOrder {
    DESC = 'DESC',
    ASC = 'ASC'
}

export enum InvoiceColumn {
    ID = 'ID',
    CreatedDate = 'CreatedDate',
    WebOrderId = 'WebOrderId',
    OrderNumber = 'OrderNumber',
    PrintStatus = 'PrintStatus',
    PrintedDate = 'PrintedDate',
    PrintByUser = 'PrintByUser',
    OrderStatusId = 'OrderStatusId'
}

export class OrderStatusConstants {
    public static COMPLETED = 'Completed';
    public static PROCESSING = 'Processing';
    public static READY_FOR_PICK_UP = 'Ready for Pick Up';
    public static Shipped = 'Shipped';
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/reports.constants.ts